export default __webpack_public_path__ + "static/media/phishing-indentify6.ca816bd6.png";